<div class="row space-between">
  <h1>What's the product phase you are in?</h1>
  <rr-icon name="close" class="close" (click)="close()"></rr-icon>
</div>
<div class="catwrapper row">
  <div
    class="cat col"
    *ngFor="let cat of categories"
    [ngClass]="cat?.tracks?.length === 0 ? 'disabled' : ''"
    (click)="cat?.tracks?.length !== 0 ? onClickCat(cat) : null"
  >
    <div
      class="image w100"
      [style]="
        'background-image: url(' +
        serverurl +
        '/public/catimages/' +
        cat.image +
        ')'
      "
    ></div>
    <div class="content col gap-24">
      <div class="row tags">
        @for(tag of cat.tags; track tag.id){
        <rr-badge
          type="tag"
          size="mmall"
          tone="brand"
          [iconStart]="tag.icon"
          *ngIf="tag.tagGroupId === 'rkND7rr4brDsXzk1YurS5A'"
          >{{ tag.name }}</rr-badge
        >

        }
      </div>
      <h3 class="row gap-4">
        <span>{{ cat?.orderNr }}.</span><span>{{ cat?.name }}</span>
      </h3>
      <div class="row tags wrap gap-4 row-gap-8">
        @for(tag of cat.tags; track tag.id){
        <rr-badge
          type="tag"
          size="small"
          tone="neutral"
          *ngIf="tag.tagGroupId === 'a5imLeoKLjuHanmaLc565F'"
          >{{ tag.name }}</rr-badge
        >

        }
      </div>
    </div>
  </div>
</div>
